import { Flex, OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { UploadDocumentType } from "../../../types";
import { PoolBancarioDocumentUpload, useDocumentNavigationActions, MESSAGES } from "../components";

export const PoolBancarioDocumentUploadPage = () => {
  const intl = useIntl();

  const { primaryAction, secondaryAction } = useDocumentNavigationActions({
    forType: UploadDocumentType.POOL_BANCARIO,
  });

  return (
    <OnboardingLayout
      variant="wide"
      title={intl.formatMessage(MESSAGES.poolBancarioTitle)}
      actions={{ primary: primaryAction, secondary: secondaryAction }}
    >
      <Flex maxWidth="550px">
        <PoolBancarioDocumentUpload />
      </Flex>
    </OnboardingLayout>
  );
};
